import React from 'react';

import * as Styled from './all-tasks.style';
import { ActiveFilterBanner } from './components/active-filter-banner';
import { LifeAreaGroupingTasksList } from './components/life-area-grouping-tasks-list';
import { MobileAddTaskButton } from './components/mobile-add-task-button';
import { PageTopBar } from './components/page-top-bar';

export const AllTasks: React.FC = () => (
  <Styled.Container>
    <Styled.Main>
      <Styled.MainContent>
        <PageTopBar />

        <Styled.Content>
          <ActiveFilterBanner />

          <LifeAreaGroupingTasksList />
        </Styled.Content>
      </Styled.MainContent>
    </Styled.Main>

    <MobileAddTaskButton />
  </Styled.Container>
);
